import { renderSocialBlock } from '../render/blocks/social';
import { SocialBlockSettings } from '../settings/blocks/social';
import { defineBlockRegistryEntry } from './defineEntry';
import { socialBlockDefinition } from '../domain/blocks/social';
import { blockWidthAlignMargins } from '../domain/block-width';

export const socialBlockRegistryEntry = defineBlockRegistryEntry(
  socialBlockDefinition,
  renderSocialBlock,
  SocialBlockSettings,
  {
    boxStyle: block =>
      block.type === 'social'
        ? {
            width: 'fit-content',
            maxWidth: '100%',
            ...blockWidthAlignMargins(block.align),
          }
        : undefined,
  },
);
